'use client';

// src/spinner.tsx
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["label", "thickness", "speed", "emptyColor", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { chakra, forwardRef, keyframes, omitThemingProps, useStyleConfig } from "@chakra-ui/system";
import { cx } from "@chakra-ui/shared-utils";
import { jsx } from "react/jsx-runtime";
var spin = keyframes({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
});
var Spinner = forwardRef(function (props, ref) {
  var styles = useStyleConfig("Spinner", props);
  var _omitThemingProps = omitThemingProps(props),
    _omitThemingProps$lab = _omitThemingProps.label,
    label = _omitThemingProps$lab === void 0 ? "Loading..." : _omitThemingProps$lab,
    _omitThemingProps$thi = _omitThemingProps.thickness,
    thickness = _omitThemingProps$thi === void 0 ? "2px" : _omitThemingProps$thi,
    _omitThemingProps$spe = _omitThemingProps.speed,
    speed = _omitThemingProps$spe === void 0 ? "0.45s" : _omitThemingProps$spe,
    _omitThemingProps$emp = _omitThemingProps.emptyColor,
    emptyColor = _omitThemingProps$emp === void 0 ? "transparent" : _omitThemingProps$emp,
    className = _omitThemingProps.className,
    rest = _objectWithoutProperties(_omitThemingProps, _excluded);
  var _className = cx("chakra-spinner", className);
  var spinnerStyles = _objectSpread({
    display: "inline-block",
    borderColor: "currentColor",
    borderStyle: "solid",
    borderRadius: "99999px",
    borderWidth: thickness,
    borderBottomColor: emptyColor,
    borderLeftColor: emptyColor,
    animation: "".concat(spin, " ").concat(speed, " linear infinite")
  }, styles);
  return /* @__PURE__ */jsx(chakra.div, _objectSpread(_objectSpread({
    ref: ref,
    __css: spinnerStyles,
    className: _className
  }, rest), {}, {
    children: label && /* @__PURE__ */jsx(chakra.span, {
      srOnly: true,
      children: label
    })
  }));
});
Spinner.displayName = "Spinner";
export { Spinner };